import { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as AppActions from '../../actions/AppActions';
import { GROUP } from 'ContentUtils/constants/CustomWidgetFieldTypes';
const mapDispatchToProps = {
  blurField: AppActions.blurField,
  focusField: AppActions.focusField
};
const connector = connect(null, mapDispatchToProps);
class ThemeSettingsFieldWrapper extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleFocusField = () => {
      const {
        fieldKey,
        focusField
      } = this.props;
      if (fieldKey) focusField(fieldKey.join('.'));
    };
    this.handleBlurField = () => {
      const {
        blurField,
        fieldKey
      } = this.props;
      if (fieldKey) blurField(fieldKey.join('.'));
    };
  }
  componentDidMount() {
    const {
      fieldKey
    } = this.props;
    this.fieldEl = fieldKey ? document.querySelector(`[data-field-key="${fieldKey.join('.')}"]`) : null;
    if (this.fieldEl && !this.isFieldGroup) {
      this.fieldEl.addEventListener('mouseenter', this.handleFocusField);
      this.fieldEl.addEventListener('mouseleave', this.handleBlurField);
    }
  }
  componentWillUnmount() {
    if (this.fieldEl && !this.isFieldGroup) {
      this.fieldEl.removeEventListener('mouseenter', this.handleFocusField);
      this.fieldEl.removeEventListener('mouseleave', this.handleBlurField);
    }
  }
  get isFieldGroup() {
    const {
      field
    } = this.props;
    return field.type === GROUP;
  }
  render() {
    return this.props.children;
  }
}
export default connector(ThemeSettingsFieldWrapper);